import styled from 'styled-components';

export const TankDetailsMain = styled.div`
  display: grid;
  gap: 2rem;
  border: 1px solid #adadad;
  padding: 2rem;
  margin-top: 0.5rem;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
`;

export const DetailsSectionHeader = styled.h4`
  font-size: 16px;
  font-weight: 700;
  color: #4b286d;
  margin-bottom: 0.5rem;
`;
